/* unplugin-vue-components disabled */import { render } from "./ActivityLogs.vue?vue&type=template&id=ca8670a8&scoped=true"
import script from "./ActivityLogs.vue?vue&type=script&lang=js"
export * from "./ActivityLogs.vue?vue&type=script&lang=js"

import "./ActivityLogs.vue?vue&type=style&index=0&id=ca8670a8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca8670a8"]])

export default __exports__